import { render, staticRenderFns } from "./BaseLabel.vue?vue&type=template&id=195ace50"
import script from "./BaseLabel.vue?vue&type=script&lang=js"
export * from "./BaseLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/Companion.WebApp/ClientApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('195ace50')) {
      api.createRecord('195ace50', component.options)
    } else {
      api.reload('195ace50', component.options)
    }
    module.hot.accept("./BaseLabel.vue?vue&type=template&id=195ace50", function () {
      api.rerender('195ace50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ui/BaseLabel.vue"
export default component.exports